import { createContext } from "react"

export interface PointerPosition {
  x: number
  y: number
}

export interface PointerPositionContextType {
  getPointerPosition: () => PointerPosition | null
}

// Default no-op function that returns null
const defaultGetPointerPosition = () => null

export const PointerPositionContext = createContext<PointerPositionContextType>(
  {
    getPointerPosition: defaultGetPointerPosition
  }
)
